export function setDate(date: string) {
  if (!date) return ''
  let dateFormatted = ''
  const dateObj = new Date(date)
  dateFormatted = dateObj.toLocaleDateString('en-AU', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })

  return dateFormatted
}
